import MeshObjectCreator from "../../../output/assets/objects/mesh-object-creator.js";

function setMaterial(oldMaterial, newMaterial) {
    if (Array.isArray(newMaterial)) {
        if (Array.isArray(oldMaterial)) {
            oldMaterial.length = newMaterial.length;

            for (const [i, material] of newMaterial.entries()) {
                oldMaterial[i] = material;
            }

            return oldMaterial;
        } else {
            return newMaterial.slice();
        }
    } else {
        return newMaterial;
    }
}

class ThreeMeshObjectCreator extends MeshObjectCreator {
    constructor(MeshObject) {
        super();
        this._MeshObject = MeshObject;
    }

    create(geometry, material) {
        const MeshObject = this._MeshObject;
        return new MeshObject(geometry, setMaterial(null, material));
    }

    dispose(object) {}

    setGeometry(object, geometry) {
        object.geometry = geometry;
    }

    setMaterial(object, material) {
        object.material = setMaterial(object.material, material);
    }
}

export default ThreeMeshObjectCreator;
